import React, { useEffect } from 'react';
import './MechDesign.css';

const MechDesign = () => {
    useEffect(() => {
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => observer.observe(element));

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Structural Design",
            description: "Engineering robust structures to ensure durability and stability in IoT and embedded devices."
        },
        {
            title: "Enclosure and Packaging Design",
            description: "Designing protective enclosures for IoT devices to enhance functionality and aesthetics."
        },
        {
            title: "Thermal Management Design",
            description: "Developing thermal solutions to maintain optimal operating temperatures for embedded systems."
        },
        {
            title: "Mechanism and Actuation Design",
            description: "Creating mechanical systems for precise movement and actuation in IoT applications."
        },
        {
            title: "Material Selection Design",
            description: "Selecting materials to balance strength, weight, and cost for IoT device components."
        },
        {
            title: "Tolerance and Fit Design",
            description: "Ensuring precise tolerances and fits for reliable assembly of mechanical parts."
        },
        {
            title: "Prototyping and 3D Printing Design",
            description: "Utilizing 3D printing for rapid prototyping to validate mechanical designs."
        },
        {
            title: "Mechanical Testing Design",
            description: "Implementing rigorous testing to ensure mechanical reliability and performance."
        },
        {
            title: "Manufacturing Process Design",
            description: "Optimizing manufacturing processes for efficient production of mechanical components."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                Mechanical Design and Development
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our mechanical design services deliver innovative, reliable, and efficient solutions for IoT and embedded systems, ensuring seamless integration and optimal performance.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default MechDesign;